import { gql } from '@apollo/client';

import { Types } from '../../../../types';
import { orderIncomingTeams } from '../utils';

import { FragmentType } from './types';

export const lives_live: FragmentType<'lives_live'> = {
  merge: (existing, incoming, options) => {
    const eventId = options.readField<number>('event_id', incoming);
    if (!eventId) {
      return incoming;
    }

    let status = options.readField('status', incoming);
    if (!status) {
      status = options.readField('status', existing);
    }

    let teams = options.readField<Types.Lives_Live_Team[]>('teams', incoming);
    if (!teams) {
      teams = options.readField<Types.Lives_Live_Team[]>('teams', existing);
    }

    const eventDetailTeams = teams?.map((team) => {
      const teamRef = team as unknown as import('@apollo/client').StoreObject;
      const role = options.readField('role', teamRef);
      const score = options.readField('score', teamRef);
      const data = options.readField('data', teamRef);

      return {
        role,
        score,
        data,
      };
    });

    // Lorsque l'on recoit des données sur le score via lives_live,
    // on met à jour competitions_event_detail
    options.cache.updateFragment<{ teams: unknown[]; status: unknown }>(
      {
        id: `competitions_event_detail:${eventId}`,
        fragment: gql`
          fragment UpdateCompetitionsEventDetail on competitions_event_detail {
            teams
            status
          }
        `,
      },
      (data) => {
        if (!data) return data;
        return {
          ...data,
          teams: ['home', 'away'].map((_, idx) => ({
            ...((data.teams?.[idx] as Record<string, unknown>) || {}),
            ...(eventDetailTeams?.[idx] || {}),
          })),
          status,
        };
      }
    );

    return incoming;
  },
  fields: {
    teams: orderIncomingTeams(),
  },
};
